import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import {registerLocale} from "react-datepicker";
import { de } from 'date-fns/locale/de';

import ErrorScreen from "./components/ErrorScreen";
import {createBrowserRouter, RouterProvider} from "react-router-dom";

import './App.scss';
import NobiliaForm from "./components/NobiliaForm";
import AssembledForm from "./components/AssembledForm";
import DisassembledForm from "./components/DisassembledForm";
import AssembledCustomForm from "./components/AssembledCustomForm";

registerLocale('de', de);

// const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

const router = createBrowserRouter([
    {
        path: "/",
        element: <NobiliaForm/>,
        errorElement: <ErrorScreen/>
    },
    {
        path: "/nobilia",
        element: <NobiliaForm/>
    },
    {
        path: "/vormontiert",
        element: <AssembledForm/>
    },
    {
        path: "/vormontiert-individualanfrage",
        element: <AssembledCustomForm/>
    },
    {
        path: "/zerlegt",
        element: <DisassembledForm/>
    },
], {
    basename: '/preisrechner-app'
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);
reportWebVitals();
